import { Checkmark } from "../svgs";

interface UnorderedListProps {
    items: string[];
    hasCheckmark?: boolean
}

export const UnorderedList = ({ items, hasCheckmark = true }: UnorderedListProps) => {
    return (
        <ul className="space-y-1 flex flex-col items-center mx-auto">
            {items.map((item, index) => (
                <li key={index} className="flex items-center gap-3 max-w-max pt-1">
                    {hasCheckmark && Checkmark}
                    <span className="text-white leading-relaxed">
                        {item}
                    </span>
                </li>
            ))}
        </ul>
    )
}